<template>
  <div>
    <div class="search-name">
      <h2 class="search-title">{{search.query.businessUnit}} {{ minDate | momentFilter }} - {{ maxDate | momentFilter }}</h2>
      <div @click="showMenu">
        <div class="menu-hamburger" ></div>
      </div>
      <div class="dropdown-container" v-show="show">
        <div class="dropdown-menu">
          <div class="triangle triangle-4"></div>
          <div class="drop-text drop-btn" v-on:click="showSaveQueryModal()">
            {{$t('searchName.save')}}
            <div class="dropdown-save"></div>
          </div>
          <div class="drop-text drop-btn" @click="exportClients">
            {{$t('searchName.export')}}
            <div class="dropdown-export"></div>
          </div>
          <div class="drop-text drop-btn" @click="removeSearch">
            {{$t('searchName.delete')}}
            <div class="dropdown-delete"></div>
          </div>
          <div class="drop-text drop-btn" @click="importFile">
            {{$t('searchName.import')}}
            <div class="dropdown-import"></div>
          </div>
        </div>
      </div>
      <SaveQuery v-if='isSaveQueryModalVisible' @closeModal="onCloseModal" :search="search"></SaveQuery>
    </div>
  </div>
</template>

<script>
  import SaveQuery from './SaveQuery.vue'
  import axios from 'axios'
  import buildQuery from '../buildQuery'
  import moment from 'moment'

  export default {
    name: 'SearchName',
    components: {SaveQuery},
    props: {
      search: Object,
      query: Object,
      result: Object
    },
    filters: {
      momentFilter: function (date) {
        if (!date || date === '') {
          return ''
        }
        return moment(date).format('DD/MM/YYYY');
      }
    },
    computed: {
      startDateStr() {
        if (this.search && this.search.query && this.search.query.period && this.search.query.period.startDate) {
          return moment(String(this.search.query.period.startDate)).format('DD/MM/YYYY')
        }
        return ''
      },
      endDateStr() {
        if (this.search && this.search.query && this.search.query.period && this.search.query.period.endDate) {
          return moment(String(this.search.query.period.endDate)).format('DD/MM/YYYY')
        }
        return ''
      },
      addZero() {
        return (this.search.id < 10) ? '0' + this.search.id : this.search.id
      },
      minDate() {
        if (this.result && this.result.aggregations && this.result.aggregations["to-bills"] && this.result.aggregations["to-bills"].bills && this.result.aggregations["to-bills"].bills.minDate) {
          return this.result.aggregations["to-bills"].bills.minDate.value
        }
        return null
      },
      maxDate() {
        if (this.result && this.result.aggregations && this.result.aggregations["to-bills"] && this.result.aggregations["to-bills"].bills && this.result.aggregations["to-bills"].bills.maxDate) {
          return this.result.aggregations["to-bills"].bills.maxDate.value
        }
        return null
      }
    },
    data() {
      return {
        show: false, 
        isSaveQueryModalVisible: false
      }
    },
    mounted() {
      let that = this
      window.addEventListener('click', function(event){
        if(event.target.className != 'menu-hamburger' && !event.target.classList.contains('dropdown-menu') && !event.target.classList.contains('drop-btn')) {
          that.show = false
        }
      });
    },
    methods: {

      showMenu() {
        this.show = !this.show
      },
      onCloseModal() {
        this.isSaveQueryModalVisible = false
      },
      removeSearch() {
        this.$emit('removeSearch', this.search)
      }, 
      importFile() {
        this.show = false
        this.$emit('importFile', this.search)
      },
      showSaveQueryModal () {
        this.isSaveQueryModalVisible = true
      },
      exportClients() {
        const query = buildQuery(this.search.query)
        axios.post(this.$store.state.user.url + '/exportClients', query, {headers: {'request_uuid': this.last_request,
          'Authorization': 'Bearer ' + this.$store.state.user.token
          }, responseType: 'blob'})
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'clients.csv');
            document.body.appendChild(link);
            link.click();
          })
      }
    },
    watch : {
      
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/search_name.sass"
</style>
